import { Injectable } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { alphanumericValidator } from 'avn/shared/directives/alphanumeric.validator';
import * as moment from 'moment';
import { Subject, BehaviorSubject } from 'rxjs';

export const TIMER_DURATION = 60;
export const TEMP_APPOINTMENT_DURATION = 300;

interface ActivePolicy {
  active: boolean;
  version: string;
  link: string;
}

@Injectable({
  providedIn: 'root'
})
export class BookingStoreService {
  constructor(
    private fb: FormBuilder,
    private router: Router
  ) {
    this.setupNameCapitalization();
  }

  bookingCompleteStatusList: any = {
    service: true,
    practitioner: false,
    datetime: false,
    customer: false,
    confirm: false
  };

  startTimerSub = new Subject();

  bookingLayout: 'webpage' | 'mobile' = 'webpage';

  isAppointmentOrClass: 'Appointment' | 'Classes' = 'Appointment';

  bookingTemporarySlug: string;

  currentFlow: 'appointment' | 'time' | 'customer' | 'checkout' = 'appointment';

  showPop: '' | 'practitioners' | 'service_type' | 'validate_email' | 'mobile_address' = '';

  servicePractitioners: any[] = [];

  loggedUser: any;

  businessDetail: any = {};
  businessSlug = '';

  serviceParam = '';
  serviceUuid = '';
  selectedServiceId: number;
  selectedServiceDetail: any = {};

  serviceDetail: any = {};
  serviceListObj: any = {};

  practitionerId: string | number = '';
  practitionerDetail: any = {};

  selectedDate = '';
  selectedTime = '';

  apiLoading = false;

  appointmentType: '' | 'In Person' | 'Online' | 'Mobile';

  getComponentRelatedCalls = new Subject();

  wellbeingCreditApplied = 0;

  customerForm: FormGroup = this.fb.group({
    claim_number: ['', [Validators.required]],
    customer_name: ['', [Validators.required, Validators.minLength(2), alphanumericValidator]],
    customer_last_name: ['', [Validators.required, Validators.minLength(2), alphanumericValidator]],
    customer_email: ['', [Validators.required, Validators.email]],
    customer_dob: ['', [Validators.required]],
    customer_phone: ['', [Validators.required]],
    country_code: ['+61', [Validators.required]],
    appointment_notes: ['']
  });

  phoneObject: { phone_number: string; country_code: string } = { phone_number: '', country_code: '+61' };

  tempApptResponse: any;
  serviceResponse: any;

  // eslint-disable-next-line prettier/prettier
  // tempApptResponse = {'id':18219,'appointment_start_time':'01:45 PM','appointment_end_time':'02:45 PM','appointment_date':'2025-01-30','practitioner_detail':{'id':8401,'uuid':'e9061244-b346-4503-a487-39fffde423b5','name':'Kamal B','profession_title':'Physiotherapist','practitioner_gender':'Male','practitioner_status':'Active','profile':'','business':2543,'correct_image':'http://res.cloudinary.com/avaana/image/upload/onls4rtq4fbary1jdbpe.webp','software':'','link':'','suburb':'','post_code':''},'business_detail':{'id':2543,'name':'Kamal Biz Test','mobile_booking':false,'online_booking':false,'slug':'kamalakar-test-1','premium':true,'business_photos':[{'id':2871,'image':null,'correct_image':'http://res.cloudinary.com/avaana/image/upload/w_700,h_400,c_limit/q_auto/f_auto/qt1yjluhhnetaggqkyun.webp','name':'pngimg.com - mario_PNG125.png','type_of_url':'Image','thumb_image':'http://res.cloudinary.com/avaana/image/upload/dfeimmk6nmqtjdhvwxgc.webp','priority':1,'business':2543},{'id':2872,'image':null,'correct_image':'http://res.cloudinary.com/avaana/image/upload/w_700,h_400,c_limit/q_auto/f_auto/zxwmlt47doxgzeytcasg.webp','name':'jonathan-borba-0KGct860xWA-unsplash.jpg','type_of_url':'Image','thumb_image':'http://res.cloudinary.com/avaana/image/upload/lawmhuyb9hvmf9cltogr.webp','priority':1,'business':2543},{'id':2862,'image':null,'correct_image':'http://res.cloudinary.com/avaana/image/upload/w_700,h_400,c_limit/q_auto/f_auto/x1se6am81jeeunhgwdte.webp','name':'sule-makaroglu-8W8v51pVbEo-unsplash.jpg','type_of_url':'Image','thumb_image':'http://res.cloudinary.com/avaana/image/upload/wfykccottzzqrnhh6cxa.webp','priority':1,'business':2543},{'id':2863,'image':null,'correct_image':'http://res.cloudinary.com/avaana/image/upload/w_700,h_400,c_limit/q_auto/f_auto/ive58ombqrgwfaznsag9.webp','name':'marc-zeman-uLWW09LLG04-unsplash.jpg','type_of_url':'Image','thumb_image':'http://res.cloudinary.com/avaana/image/upload/wd3tuacuesvvxceg6oir.webp','priority':1,'business':2543}],'business_detail':{'id':1348,'logo_image':null,'correct_image':'http://res.cloudinary.com/avaana/image/upload/aucepepip3rsubugqtuj.webp','business_profile':'Ignore this','business_profile_major_city':null,'business_profile_subhurb':null,'logo_name':'butterfly-colorful-logo-template.jpg','cancelation_policy':48,'max_lead_time':3,'max_feature_time':1,'website':null,'facebook_link':null,'instagram_link':null,'certifications':null,'insurance_accepted':'Yes','business_incorporation':'2022','security_policy':null,'provide_service':'In Person','philosophy':null,'in_person_service':true,'mobile_service':false,'suburb':null,'post_code':null,'business_radius':5,'online_service':false,'software':null,'link':null,'booking_mode':'Google','booking_mode_api':'','google_rating':0,'google_total_reviews':0},'business_location':{'id':2839,'distance':0,'uuid':'a95f572f-1e09-41ac-8516-f549025efe23','address':'Melbourne VIC','apartment':'','street':'Melbourne','city':'Melbourne','state':'VIC','postal_code':'3000','lat':-37.8136276,'lng':144.9630576,'registered_address':true,'operational_address':true,'is_active':true,'mobile_based_clinic':false,'business':2543}},'promo_code':{},'service_uuid':'58d3d929-48dd-498b-a47a-33df035d036c','class_uuid':'','wellbeing':false,'temp_slug':'e386ff06-fe61-4ac0-9c62-ed95612c6c61','business_address':'Melbourne VIC','suburb':'Melbourne','state':'VIC','customer_name':null,'customer_last_name':null,'customer_email':null,'country_code':null,'customer_phone':null,'service_name':'Physio with Kamal','category_name':'Physiotherapy','appointment_type':'Appointment','promo_code_percent':0,'appointment_status':'In Process','payment_type':null,'is_gift':false,'gift_full_name':null,'gift_email':null,'gift_message':'','appointment_notes':'','visit_reason':'','booking_type':'In Person','booking_address':'','booking_apartment':null,'booking_suburb':null,'booking_state':null,'booking_post_code':null,'meeting_id':null,'is_active':false,'employee':null,'journey':null,'category':null,'business':2543,'business_owner':2495,'business_practitioner':8401,'customer':null,'service_id':35091,'class_id':null,'promo_code_id':null}
  // eslint-disable-next-line prettier/prettier
  // serviceResponse = {'message':'Business Appointment Detail fetched successfully.','data':{'id':35091,'business_data':{'id':2543,'business_service':[{'id':35091,'service_image':null,'image1':null,'image2':null,'images':[],'service_practitioner_detail':[{'id':8401,'name':'Kamal B','slug':'kamal-b','email':'kamal@gmail.com','online_enabled':false,'software':'','mobile_enabled':false}],'uuid':'58d3d929-48dd-498b-a47a-33df035d036c','service_name':'Physio with Kamal','improvised_name':null,'description':'','slug':'physio-with-kamal','category_name':'Physiotherapy','length_of_service':'60 mins','service_practitioner':['Kamal B'],'price':80,'discount':20,'discount_description':'','badges':null,'mode_of_service':['In Person'],'priority':1,'buffer_time':false,'before_appointment':null,'after_appointment':null,'minimum_notice':false,'minimum_notice_amount':null,'daily_limit':false,'daily_limit_count':null,'hide_in_market_place':false,'business':2543}],'business_practitioner':[{'id':8401,'logo_image':'http://res.cloudinary.com/avaana/image/upload/onls4rtq4fbary1jdbpe.webp','practitioner_service':['Physio with Kamal'],'practitioner_service_category':[{'category_name':'Physiotherapy'}],'uuid':'e9061244-b346-4503-a487-39fffde423b5','slug':'kamal-b','name':'Kamal B','email':'kamal@gmail.com','logo_name':'Female Avatar','practitioner_gender':'Male','profession_title':'Physiotherapist','spoken_languages':[],'specialization':[],'qualification':[],'profile':'','practitioner_certificates':[],'practitioner_hours':[{'error':false,'day_status':'Open','end_timing':'06:00 PM','business_day':'Monday','start_timing':'08:00 AM'},{'error':false,'day_status':'Open','end_timing':'06:00 PM','business_day':'Tuesday','start_timing':'08:00 AM'},{'error':false,'day_status':'Open','end_timing':'06:00 PM','business_day':'Wednesday','start_timing':'08:00 AM'},{'error':false,'day_status':'Open','end_timing':'06:00 PM','business_day':'Thursday','start_timing':'08:00 AM'},{'error':false,'day_status':'Open','end_timing':'06:00 PM','business_day':'Friday','start_timing':'08:00 AM'},{'error':false,'day_status':'Closed','end_timing':'06:00 PM','business_day':'Saturday','start_timing':'08:00 AM'},{'error':false,'day_status':'Closed','end_timing':'06:00 PM','business_day':'Sunday','start_timing':'08:00 AM'}],'practitioner_status':'Active','is_valid_sira':true,'essa':null,'online_enabled':false,'software':'','mobile_enabled':false,'rating':0,'reviews':0,'score':0,'invitation_status':'Pending','lh_hide':false,'eml_hide':false,'trinity_hide':false,'hii_hide':false},{'id':8834,'logo_image':'http://res.cloudinary.com/avaana/image/upload/pcptzo9c86djbj1ewvis.webp','practitioner_service':[],'practitioner_service_category':[],'uuid':'271d9bf5-7f5c-4cf3-81e1-72dccc1b2562','slug':'shehnaz','name':'Shehnaz','email':'shehnaz@avaana.com.au','logo_name':'Female Avatar','practitioner_gender':'Female','profession_title':'Yoga Instructor','spoken_languages':[],'specialization':[],'qualification':[],'profile':'','practitioner_certificates':[],'practitioner_hours':[],'practitioner_status':'Active','is_valid_sira':false,'essa':null,'online_enabled':false,'software':'','mobile_enabled':false,'rating':0,'reviews':0,'score':0,'invitation_status':'Pending','lh_hide':false,'eml_hide':false,'trinity_hide':false,'hii_hide':false},{'id':8835,'logo_image':'http://res.cloudinary.com/avaana/image/upload/kivjwm2ttmbjuryqt9uy.webp','practitioner_service':[],'practitioner_service_category':[],'uuid':'fa08613a-ecfc-4351-92d2-bb201ef124fb','slug':'ramzz','name':'Ramzz','email':'ram@gm.com','logo_name':'Female Avatar','practitioner_gender':'Female','profession_title':'','spoken_languages':[],'specialization':[],'qualification':[],'profile':'','practitioner_certificates':[],'practitioner_hours':[],'practitioner_status':'Active','is_valid_sira':false,'essa':null,'online_enabled':false,'software':'','mobile_enabled':false,'rating':0,'reviews':0,'score':0,'invitation_status':null,'lh_hide':false,'eml_hide':false,'trinity_hide':false,'hii_hide':false}],'business_location':{'id':2839,'distance':0,'uuid':'a95f572f-1e09-41ac-8516-f549025efe23','address':'Melbourne VIC','apartment':'','street':'Melbourne','city':'Melbourne','state':'VIC','postal_code':'3000','lat':-37.8136276,'lng':144.9630576,'registered_address':true,'operational_address':true,'is_active':true,'mobile_based_clinic':false,'business':2543},'business_detail':{'id':1348,'logo_image':null,'correct_image':'http://res.cloudinary.com/avaana/image/upload/aucepepip3rsubugqtuj.webp','business_profile':'Ignore this','business_profile_major_city':null,'business_profile_subhurb':null,'logo_name':'butterfly-colorful-logo-template.jpg','cancelation_policy':48,'max_lead_time':3,'max_feature_time':1,'website':null,'facebook_link':null,'instagram_link':null,'certifications':null,'insurance_accepted':'Yes','business_incorporation':'2022','security_policy':null,'provide_service':'In Person','philosophy':null,'in_person_service':true,'mobile_service':false,'suburb':null,'post_code':null,'business_radius':5,'online_service':false,'software':null,'link':null,'booking_mode':'Google','booking_mode_api':'','google_rating':0,'google_total_reviews':0},'uuid':'95c4d288-3946-4bc5-9af3-d9fa4418cf11','name':'Kamal Biz Test','display_logic_health':false,'contact_name':'Kamalakar','country_code':'+91','abn_valid':true,'abn_valid_timestamp':'2024-11-29T11:07:34.286225Z','slug':'kamalakar-test-1','pay_venue':'Disable','premium':true,'rating':0,'reviews':0,'score':0,'workcover_commission':30,'status':'Active'},'service_practitioner_detail':[{'id':8401,'name':'Kamal B','slug':'kamal-b','email':'kamal@gmail.com','online_enabled':false,'software':'','mobile_enabled':false}],'uuid':'58d3d929-48dd-498b-a47a-33df035d036c','service_name':'Physio with Kamal','improvised_name':null,'description':'','slug':'physio-with-kamal','category_name':'Physiotherapy','length_of_service':'60 mins','service_practitioner':['Kamal B'],'price':80,'discount':20,'discount_description':'','image1':null,'image2':null,'badges':null,'mode_of_service':['In Person'],'service_image':null,'priority':1,'buffer_time':false,'before_appointment':null,'after_appointment':null,'minimum_notice':false,'minimum_notice_amount':null,'daily_limit':false,'daily_limit_count':null,'business':2543}}

  // CHECKOUT RELATED VARIABLES
  promoCode: string;
  promoApplied = false;
  promoValidated: any = {};

  paymentMode: '' | 'venue' | 'creditcard' | 'helloclever' | 'wellbeingcredit' = '';

  // Credit card valid flags
  cardNumberValid = false;
  cardExpiryValid = false;
  cardCvvValid = false;
  stripePayment: any;
  stripeCardNumberElement: any;
  stripeCardExpElement: any;
  stripeCardCVVElement: any;

  // Pay at venue OTP
  venueOtp = '';

  formattedAppointmentTime = '';
  progressPercentage = 100;

  circumference = 2 * Math.PI * 45;
  strokeDashoffset: number = this.circumference;

  isVenue = false;
  isOnline = false;
  isMobile = false;

  bTMobileAddress = {
    address: '',
    apartment: '',
    suburb: '',
    state: '',
    post_code: ''
  };

  isChecked = false;
  isPolicyChecked = false;
  isReportChecked = false;
  policiesApiLoading = false;

  activePolicies: { tc: ActivePolicy; privacy: ActivePolicy; health: ActivePolicy } = {
    tc: { active: false, version: '', link: '' },
    privacy: { active: false, version: '', link: '' },
    health: { active: false, version: '', link: '' }
  };

  emailExists = false;

  private _selectedPractitionerLocation$ = new BehaviorSubject<any>({});

  public selectedPractitionerLocation$ = this._selectedPractitionerLocation$.asObservable();

  setActivePolicies(response: any): void {
    const policies = response || {};

    this.activePolicies = {
      tc: {
        active: !!policies.tc_link,
        version: policies.tc_version || '',
        link: policies.tc_link || ''
      },
      privacy: {
        active: !!policies.privacy_link,
        version: policies.privacy_version || '',
        link: policies.privacy_link || ''
      },
      health: {
        active: !!policies.health_link,
        version: policies.health_version || '',
        link: policies.health_link || ''
      }
    };
  }

  initSelectedPractitionerLocationFromService(): void {
    const location = this.serviceDetail?.business_data?.business_location || {};
    this._selectedPractitionerLocation$.next(location);
  }

  setSelectedPractitionerLocation(location: any): void {
    this._selectedPractitionerLocation$.next(location);
  }

  getSelectedPractitionerLocation(): any {
    return this._selectedPractitionerLocation$.getValue();
  }

  private setupNameCapitalization(): void {
    const capitalizeControl = (controlName: 'customer_name' | 'customer_last_name') => {
      const control = this.customerForm.get(controlName);
      control?.valueChanges.subscribe((value: string) => {
        if (typeof value !== 'string' || !value.length) {
          return;
        }
        const capitalized = value.charAt(0).toUpperCase() + value.slice(1);
        if (capitalized !== value) {
          control.setValue(capitalized, { emitEvent: false });
        }
      });
    };

    capitalizeControl('customer_name');
    capitalizeControl('customer_last_name');
  }

  capitalizeNameField(controlName: 'customer_name' | 'customer_last_name', value: string): void {
    const control = this.customerForm.get(controlName);
    if (!control || typeof value !== 'string' || !value.length) {
      return;
    }
    const capitalized = value.charAt(0).toUpperCase() + value.slice(1);
    if (capitalized !== value) {
      control.setValue(capitalized, { emitEvent: false });
    }
  }

  checkIfMoreThanOneActive() {
    return [this.isVenue, this.isOnline, this.isMobile].filter(Boolean).length > 1;
  }

  checkIsAppointTypeAvailable() {
    this.isOnline =
      this.serviceDetail?.business_data?.business_detail?.online_service &&
      this.selectedServiceDetail?.mode_of_service?.indexOf('Online') > -1 &&
      this.practitionerDetail.logic_health_online;
    this.isMobile =
      this.serviceDetail?.business_data?.business_detail?.mobile_service &&
      this.selectedServiceDetail?.mode_of_service?.indexOf('Mobile') > -1 &&
      this.practitionerDetail.logic_health_mobile;
    this.isVenue =
      this?.selectedServiceDetail?.mode_of_service?.indexOf('In Person') > -1 &&
      this.practitionerDetail.logic_health_partner;
  }

  resetBookingData() {
    this.bookingCompleteStatusList = {
      service: true,
      practitioner: false,
      datetime: false,
      customer: false,
      confirm: false
    };
    this.isAppointmentOrClass = 'Appointment';
    this.bookingTemporarySlug = '';
    this.currentFlow = 'appointment';
    this.businessDetail = {};
    this.businessSlug = '';
    this.serviceParam = '';
    this.serviceUuid = '';
    this.selectedServiceId = 0;
    this.selectedServiceDetail = {};
    this.serviceDetail = {};
    this.serviceListObj = {};
    this.practitionerId = 0;
    this.practitionerDetail = {};
    this.selectedDate = '';
    this.selectedTime = '';
    this.appointmentType = '';
    this.wellbeingCreditApplied = 0;
    this.tempApptResponse = {};
    this.serviceResponse = {};
    this.promoCode = '';
    this.promoApplied = false;
    this.promoValidated = false;
    this.paymentMode = '';
    this.cardNumberValid = false;
    this.cardExpiryValid = false;
    this.cardCvvValid = false;
    this.venueOtp = '';
    this.formattedAppointmentTime = '';
    this.progressPercentage = 100;
    this.emailExists = false;
    sessionStorage.removeItem('app-duration');
  }

  updateCompleteStatus() {
    this.bookingCompleteStatusList = {
      service: !!(this.bookingTemporarySlug || this.serviceParam),
      practitioner: !!(this.bookingTemporarySlug || this.practitionerId),
      datetime: !!(this.bookingTemporarySlug || (this.selectedDate && this.selectedTime)),
      customer: !!this.bookingTemporarySlug,
      confirm: false
    };
  }

  updateFormattedCountdown(time: any) {
    return moment(time * 1000)
      .utc()
      .format('mm:ss');
  }

  updateProgressBar(timeleft: any, duration: any) {
    return (timeleft / duration) * 100;
  }

  fetchProviderDiscount() {
    if (this.selectedServiceDetail.discount > 0) {
      return this.selectedServiceDetail.price - this.selectedServiceDetail.discount;
    }
    return 0;
  }

  fetchPromoDiscount() {
    if (this.promoApplied) {
      if (this.selectedServiceDetail.discount > 0) {
        const disc = (this.selectedServiceDetail.discount * this.promoValidated.percent) / 100;
        return disc;
      } else {
        const disc = (this.selectedServiceDetail.price * this.promoValidated.percent) / 100;
        return disc;
      }
    } else {
      return 0;
    }
  }

  computeFinalPrice() {
    let price = this.selectedServiceDetail?.price || 0;
    if (this.selectedServiceDetail && this.selectedServiceDetail.discount && this.selectedServiceDetail.discount > 0) {
      price = this.selectedServiceDetail.discount;
    }
    if (this.promoApplied) {
      const disc = (price * this.promoValidated.percent) / 100;
      price = price - disc;
    }
    if (this.wellbeingCreditApplied > 0) {
      price = price - this.wellbeingCreditApplied;
    }
    return price;
  }

  generateEndTime() {
    let extend = this.selectedServiceDetail.length_of_service || '';
    let hours_to_extend = 0;
    let minutes_to_extend = 0;

    if (!isNaN(Number(extend))) {
      extend += ' mins';
    }

    const hours_to_check = extend.toLowerCase().split('hr');
    if (!isNaN(Number(hours_to_check[0]))) {
      hours_to_extend = Number(hours_to_check[0]);
      extend = hours_to_check[1];
    }
    const minutes_to_check = extend.toLowerCase().split('mins');
    if (!isNaN(Number(minutes_to_check[0]))) {
      minutes_to_extend = Number(minutes_to_check[0]);
    }

    return moment(this.selectedTime, 'hh:mmA')
      .add(minutes_to_extend, 'minutes')
      .add(hours_to_extend, 'hours')
      .format('hh:mm A');
  }

  goToPractitionerPage(id: string | number) {
    let url = `booking/${this.businessSlug}/${this.serviceParam}/${id}`;
    if (this.selectedDate) {
      url += `/${this.selectedDate}`;
    }
    if (this.selectedTime) {
      url += `/${this.selectedTime}/${this.currentFlow}`;
    }

    let queryParams: any = {};
    queryParams = this.parseQueryString(sessionStorage.getItem('path-query') || '');

    this.router.navigate([url], {
      queryParams: queryParams
    });
  }

  goToTimePage() {
    let url = `booking/${this.businessSlug}/${this.selectedServiceDetail.uuid}${
      this.isAppointmentOrClass === 'Appointment' ? 'a' : 'c'
    }${this.getBookingTypeUrlExt()}/${this.practitionerId}`;
    if (this.bookingLayout === 'mobile') {
      url += '/time';
    }

    let queryParams: any = {};
    queryParams = this.parseQueryString(sessionStorage.getItem('path-query') || '');

    this.router.navigate([url], {
      queryParams: queryParams
    });
  }

  changeAppointmentType(appoint_type: 'In Person' | 'Online' | 'Mobile') {
    this.appointmentType = appoint_type;
  }

  getBookingTypeUrlExt() {
    switch (this.appointmentType) {
      case 'In Person':
        return 'p';
      case 'Mobile':
        return 'm';
      case 'Online':
        return 'o';
      default:
        return '-';
    }
  }

  getBookingTypeExt(ext: '-' | 'p' | 'o' | 'm') {
    switch (ext) {
      case 'p':
        return 'In Person';
      case 'm':
        return 'Mobile';
      case 'o':
        return 'Online';
      default:
        return '';
    }
  }

  parseQueryString(query: string) {
    if (query.includes('?')) {
      query = query.split('?')[1];
    }
    const params = new URLSearchParams(query);
    const result: any = {};

    params.forEach((value, key) => {
      // Convert numeric strings to actual numbers if possible
      const numberValue = Number(value);
      result[key] = isNaN(numberValue) ? value : numberValue;
    });

    return result;
  }
}
